module.exports = __webpack_public_path__ + "img/wild_4.3c2bff76.png";